import { useMemo } from 'react'
import { routes } from '@/routes'
import { matchPath, useLocation, useNavigation } from '@sevenrooms/navigation'

export const useModifyReservationRoute = () => {
  const { matchQuery, matchParams } = useNavigation()
  const { pathname } = useLocation()
  const { venueKey } = matchParams(routes.reservations) ?? {}
  const { lang, token } = matchQuery(routes.reservations.modify) ?? {}

  const isModifyRoute = useMemo(() => !!matchPath(pathname, { path: routes.reservations.modify.path }), [pathname])

  return {
    token,
    lang,
    venueKey,
    isModifyRoute,
  }
}
